import { useContext } from 'react';
import { useQuery } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';

const fetchStatutoryDocs = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/statutoryDocs`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json();
};

const useStatutoryDocs = () => {
  const { token } = useContext(AuthContext); 

  return useQuery('statutoryDocs', () => fetchStatutoryDocs(token), {
  });
};

export default useStatutoryDocs;
